﻿import {IProgress} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import AttachmentType from "../enums/AttachmentType";
import IPermitsHttpClient from "../http/IPermitsHttpClient";
import {FormAttachmentData} from "../types/FormAttachmentData";
import ensureProgress from "./ensureProgress";
import {ProgressReporter} from "./progressReporter";
import reportProgress from "./reportProgress";
import {toFormData} from "./toFormData";

export async function toFormAttachments(httpClient: IPermitsHttpClient, attachments: Partial<Record<AttachmentType, FileList>> | undefined, progress?: IProgress, reporter?: ProgressReporter): Promise<FormAttachmentData[]> {
	if (attachments == null) return [];

	progress = ensureProgress(attachments, PermitTranslations.create_permit__upload_files, progress);
	const formData = await toFormData(httpClient, attachments, progress, reporter);
	const result: FormAttachmentData[] = [];

	for (let {type, data} of formData) {
		++progress.current;
		reportProgress(progress, reporter);

		result.push({
			blobId: await httpClient.files.create(data),
			type: type
		});
	}

	return result;
}
